/* eslint-disable */
import React, { useEffect, useContext } from "react";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonDateTime from "../../Common/CommonDateTime";
import { updateAFSOrderManagementFilter } from "../../../redux/actions/adminActions";
import AFSOrderDataTableFilter from "../../Common/AFSOrderDataTableFilter";
import CommonTable from "../../Common/CommonTable";

const AfterSalesDraftOrders = (props) => {
  const { tab_url } = props;
  const Dispatch = useDispatch();
  const { websocket } = useContext(WebSocketContext);
  const {
    device_id,
    AfterSalesDraftOrderList,
    selfInfo,
    AFSOrderManagmentFilter,
    sortingfor,
  } = useSelector((state) => state.adminReducers);
  const PermissionsAccess = selfInfo?.user?.permissions_access;

  // page change
  const currentFunction = (page) => {
    Dispatch(
      updateAFSOrderManagementFilter({
        [tab_url]: {
          CurrentPage: page,
        },
      })
    );
  };

  // api calling
  const APICall = () => {
    const {
      UserLimit = 10,
      UserSearch = "",
      SelectRegion = "",
      FromDate = null,
      ToDate = null,
      CurrentPage = 1,
      is_warranty_order = null,
      Franchise = null,
    } = AFSOrderManagmentFilter[tab_url] || {};

    let is_warranty_order_update =
      is_warranty_order === "all_orders" ? "" : is_warranty_order;

    let param = {
      transmit: "broadcast",
      url: "afs_order_list",
      request: {
        status: "DRAFT,RENEW",
        limit: UserLimit,
        page_no: CurrentPage,
        search: UserSearch.trim(),
        from_date: null,
        to_date: null,
        from_inv: null,
        to_inv: null,
        region_id: SelectRegion,
        order_by: sortingfor,
        sale_type_id: is_warranty_order_update,
        customer_identity: Franchise?.franchise_code
          ? Franchise?.franchise_code
          : null,
      },
      DeviceId: device_id,
    };
    if (FromDate !== "" && ToDate !== "") {
      param.request.from_date = CommonDateTime(FromDate, "YYYY-MM-DD", "hide");
      param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
    }
    wsSend_request(websocket, param);
  };

  useEffect(() => {
    APICall();
  }, [websocket, AFSOrderManagmentFilter[tab_url]]);

  useEffect(() => {
    if (sortingfor !== "" && sortingfor !== "-") {
      APICall();
    }
  }, [sortingfor]);

  // TABLE COLUMNS ARRAY
  const TableColumns = [
    {
      key: "order_code",
      label: "Order Id.",
      type: "afs_order_details",
      sort: "order_code",
      isCollapsable: false,
    },
    {
      key: "order_status",
      label: "Status",
      type: "label_order_status",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "parent_code",
      label: "Parent Order Id.",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "erp_order_type",
      label: "Seller Type",
      type: "label",
      sort: "erp_order_type",
      isCollapsable: false,
    },
    {
      key: "customer_identity",
      label: "Customer Code",
      type: "label",
      sort: "customer_identity",
      isCollapsable: false,
    },
    {
      key: "created_at",
      label: "Order Date",
      type: "date",
      sort: "created_at",
      isCollapsable: false,
    },
    {
      key: "customer_name",
      label: "SHIP To Name",
      type: "label",
      sort: "customer_name",
      isCollapsable: false,
    },
    {
      key: "billing_id",
      label: "BILL To Name",
      type: "label_get_from_franchise",
      sort: "billing_id",
      isCollapsable: false,
    },
    {
      key: "quotation_code",
      label: "Quotation Id",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "frame_number",
      label: "Frame Number",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "ticket_id",
      label: "Tickets Id",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "updated_at",
      label: "Pending Since",
      type: "pending_since",
      sort: "",
      isCollapsable: false,
    },
  ];

  return (
    <section className="Main_section">
      {/* COMMON FILTER */}
      <AFSOrderDataTableFilter
        filterType={""}
        tabName={tab_url}
        searchType={
          "Order Code, Customer code, Customer name, Sales order code, Sales invoice code, Tickets id, Quotation Id"
        }
        searchdisable={true}
        buttonvisible={false}
      />

      {/* COMMON TABLE */}
      <CommonTable
        isTableAllow={true}
        style={{
          height:
            parseInt(AfterSalesDraftOrderList?.pagination?.total_records) ===
            AfterSalesDraftOrderList?.list?.length
              ? "calc(100vh - 242px)"
              : parseInt(AfterSalesDraftOrderList?.pagination?.total_records) > 10
              ? "calc(100vh - 235px)"
              : "calc(100vh - 242px)",
        }}
        srNumber={{
          clickable: true,
          events: "AFS_ORDERS",
        }}
        isCollapsable={true}
        tabName={tab_url} // TAB URL
        PaginationCurrentPage={AFSOrderManagmentFilter[tab_url]?.CurrentPage} // TAB CURRENT PAGE
        PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
        TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
        OrderList={AfterSalesDraftOrderList} // ORDER LIST
        Pagination={AfterSalesDraftOrderList?.pagination} // CURRENT TAB PAGINATION
        EditAccess={
          selfInfo?.user?.user_type === "super_admin" ||
          PermissionsAccess?.AFSOrderManagement[0]?.Edit
        } // EDITABLE ACCESS STATE
        APIcalling={APICall}
        isActionColumnAvailable={{
          isShow: false,
          label: "retry",
          naviagte: null,
        }}
        isActionTwoColumnAvailable={{
          isShow: false,
          url: tab_url,
        }}
        isOdiFilterRowColorsAllow={false}
      />
    </section>
  );
};

export default AfterSalesDraftOrders;
